import {createContext, useContext} from "react";

const BusinessProfileSettingsContext = createContext(null);

export const useBusinessProfileSettingsContext = () =>
  useContext(BusinessProfileSettingsContext);

export default BusinessProfileSettingsContext;
